var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-9b09342188fefb54b61fd0b9946ff0fc.svg#icon-shareicon-77e07';
                    var viewUrl = 'svg-sprite-9b09342188fefb54b61fd0b9946ff0fc.svg#view-icon-shareicon-77e07';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: 'undefined',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };